import src from "IMAGE";
export default { src, width: 200, height: 50, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AI51B9Kykgf3fGcDkA8LBzkNCQhDDgkIQAYEBB8CAQEIAIlwCNOQdQr3cFwEkBELBzsPCglHDwoJSA0JCEMMCQc7KA0OC8PNjUIAAAAASUVORK5CYII="};
